/**
 * @owner @Appboy/frontend-ix
 */

import { useI18nNamespace } from "./useI18nNamespace";

export * from "./MockUsage";
export * from "./types";

export default useI18nNamespace;
